/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */
import { call } from 'redux-saga/effects';
import { combineReducers } from 'redux';
import { SagaIterator } from 'redux-saga';
import {
  Asset,
  Stream,
  LicenseOptions,
  PlaybackLicenseData,
  AssetMediaType,
  Program,
  Recording,
  XError,
  PlaybackLicenseResult,
} from '@wit/vtv-x-foundation-lib';
import * as AuthN from './authN';
import ChannelLicense from './channel';
import * as ChannelsLicensePrefetch from './channelsLicensePrefetch';
import ProgramLicense from './program';
import RecordingLicense from './recording';
import VodLicense from './vod';

export default combineReducers({
  authN: AuthN.default,
  channelsLicensedLinks: ChannelsLicensePrefetch.default,
});

export const sagas = [call(AuthN.saga), call(ChannelsLicensePrefetch.saga)];

export function* getPlaybackData(
  asset: Asset,
  stream: Stream,
  options?: LicenseOptions
): SagaIterator<PlaybackLicenseData> {
  switch (asset.mediaType) {
    case AssetMediaType.MOVIE:
    case AssetMediaType.EPISODE:
      return yield call(VodLicense.getPlaybackData, asset, stream);
    case AssetMediaType.LINEAR:
      return yield call(ChannelLicense.getPlaybackData, asset, stream);
    case AssetMediaType.EPG:
      return yield call(ProgramLicense.getPlaybackData, asset as Program, stream, options);
    case AssetMediaType.RECORDING:
      return yield call(RecordingLicense.getPlaybackData, asset as Recording, stream);
    default:
      throw XError.fromError(new Error(`Unexpected Asset type: ${asset.mediaType}`));
  }
}

export function* getPlaybackLicenseLink(
  asset: Asset,
  stream: Stream,
  options?: LicenseOptions
): SagaIterator<PlaybackLicenseResult> {
  switch (asset.mediaType) {
    case AssetMediaType.MOVIE:
    case AssetMediaType.EPISODE:
      return yield call(VodLicense.getPlaybackLicenseLink, asset, stream);
    case AssetMediaType.LINEAR:
      return yield call(ChannelLicense.getPlaybackLicenseLink, asset, stream);
    case AssetMediaType.EPG:
      return yield call(ProgramLicense.getPlaybackLicenseLink, asset as Program, stream, options);
    case AssetMediaType.RECORDING:
      return yield call(RecordingLicense.getPlaybackLicenseLink, asset as Recording, stream);
    default:
      throw XError.fromError(new Error(`Unexpected Asset type: ${asset.mediaType}`));
  }
}
